// extracted by mini-css-extract-plugin
export default {"Unicode":"Unicode_Unicode__jApZa","Uni":"Unicode_Uni__8wYgy","Image":"Unicode_Image__mNVwM"};